import axios from 'axios';

export const isTokenExpiringSoon = (expiresAt, thresholdMinutes = 5) => {
  if (!expiresAt) return false;
  const now = Date.now();
  const threshold = thresholdMinutes * 60 * 1000;
  return (expiresAt - now) < threshold;
};

export const refreshAccessToken = async () => {
  const loginStatus = localStorage.getItem('LoginStatus');
  if (loginStatus !== 'true') {
    console.log('Refresh token not attempted - user not logged in');
    throw new Error('Not logged in');
  }

  try {
    const refreshToken = document.cookie.split('; ')
      .find(row => row.startsWith('refreshToken='))
      ?.split('=')[1];

    if (!refreshToken) {
      throw new Error('No refresh token available');
    }

    const response = await axios.post(
      '/auth/refresh',
      { refreshToken },
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        timeout: 5000
      }
    );

    if (response.status === 422) {
      throw new Error('Refresh token invalid or expired');
    }

    return {
      accessToken: response.data.accessToken,
      expiresAt: Date.now() + (response.data.expiresIn * 1000)
    };
  } catch (error) {
    console.error('Refresh failed:', error.message);
    
    if (error.response?.status === 429) {
      const retryAfter = error.response.headers['retry-after'] || 15;
      console.warn(`Rate limited: ${error.response.data.message}. Retry after ${retryAfter} minutes`);
      
      localStorage.setItem('rateLimitInfo', JSON.stringify({
        timestamp: Date.now(),
        retryAfter: parseInt(retryAfter) * 60 * 1000
      }));
    }
    
    // Clear auth state on refresh failure
    localStorage.setItem('LoginStatus', 'false');
    delete axios.defaults.headers.common['Authorization'];
    
    throw error;
  }
};